<template>
  <div class="maps">
    <div class="heard">
      <div class="img">
        <img src="../../../assets/dapingImg/logo.png" alt />
          <!-- <div class="name">{{tenantName}}</div> -->
      </div>
      <div class="title">加工业务</div>
      <div class="date">
        <span>{{ nowDate + ' ' + nowWeek }}</span>
      </div>
    </div>
    <div class="container">
      <!-- 上面 -->
      <div style="height:46vh">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="left_two">
               <div class="left_h">
                  <span class="span_one">加工类型分布(吨)</span>
              </div>
              <div id="LXpie" style="height:41vh"></div>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="center" style="height:45vh">
              <div class="box">
                <p>原卷总量(吨)</p>
                <p class="font">{{tongji.originalTotal}}</p>
              </div>
              <div ><img src="../../../assets/dapingImg/xian.png" style="width:95%;margin-left:12px;"></div>
              <div class="box">
                <p>成品总量(吨)</p>
                <p class="font">{{tongji.finishedTotal}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="9">
            <div class="left_two grid-content bg-purple">
               <div class="left_h">
                  <span class="span_one">实时验收数据</span>
              </div>
             <div class="left_table">
                <div id="table">
                  <div class="tables">
                    <span class="span_one1">加工单号</span>
                    <!-- <span class="span_one">材质</span> -->
                    <span class="">加工类型</span>
                    <!-- <span class="">规格</span> -->
                    <span class="">原卷重量(吨)</span>
                    <span class="span_one3">验收人</span>
                    <span class="span_one2">验收时间</span>
                  </div>
                  <vue-seamless-scroll :data="churutableData" :class-option="optionSingleHeightTime" class="seamless-warp">
                    <ul class="item">
                      <li
                        id="li"
                        v-for="(item,index) in churutableData"
                        :key="index"
                        ref="liClass"
                      >
                        <span v-text="item.processNo" class="span1"></span>
                        <span>{{item.processType}}</span>
                        <span v-text="item.originalWeight"></span>
                        <span v-text="item.acceptanceUserName" class="span3"></span>
                        <span  class="span2">{{item.acceptanceTime | formatDate}}</span>
                      </li>
                    </ul>
                  </vue-seamless-scroll>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 下面 -->
      <div style="height:45vh">
          <el-row :gutter="20">
          <el-col :span="12">
            <div class="left_two">
               <div class="left_h">
                  <span class="span_one">加工类型统计</span>
              </div>
              <div id="zhu" style="height:41vh"></div>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="left_two">
               <div class="left_h">
                  <span class="span_one">加工量趋势</span>
              </div>
              <div id="zhe" style="height:41vh"></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { typeWeightList, totalList, trendList, PSrecordList } from '@/api/data-center-server'
export default {
  data () {
    return {
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      nowWeek: '', // 当前星期
      tongji: {},
      churutableData: [],
      timer: null

    }
  },
  created () {
    this.getDate()
    this.nowTimer = setInterval(this.getDate, 500)
  },
  mounted () {
    let that = this
    this.timer = setInterval(function () {
      that.zhuFn()
      that.zheFn()
      that.getdata()
      that.jglqsFn()
      that.yssjFn()
    }, 600000 * 6)//
    this.zhuFn()
    this.zheFn()
    this.getdata()
    this.jglqsFn()
    this.yssjFn()
  },
  methods: {
    // 实时验收数据
    yssjFn () {
      PSrecordList().then(res => {
        this.churutableData = res
      })
    },
    // 加工量趋势
    jglqsFn () {
      trendList().then(res => {
        var Data1 = []
        var Data2 = []
        var nameData = []
        console.log(res.list)
        res.forEach((item, index) => {
          nameData.push(item.transportDate)
          Data1.push(item.originalWeight)
          Data2.push(item.finishedWeight)
        })
        this.zheFn(Data1, Data2, nameData)
      })
    },
    zheFn (inData, outData, nameData) {
      let _this = this
      let idChart = _this.$echarts.init(document.getElementById('zhe'))
      // 绘制图表--折线图
      var idChartOption = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['原卷重量', '成品重量'],
          color: ['#fff'],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '6%',
          right: '8%',
          bottom: '9%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: nameData,
          // 横坐标轴颜色
          axisLine: {
            lineStyle: {
              color: '#14D5FF'
            }
          },
          axisLabel: {
            interval: 0,
            rotate: 60,
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            }
            // formatter: function (data) {
            //   let valueTxt = ''
            //   if (data.length > 5) {
            //     valueTxt = data.substring(0, 6) + '...' // 想要展示的x轴名称长度
            //   } else {
            //     valueTxt = data
            //   }
            //   return valueTxt
            // }
          }
        },
        yAxis: {
          type: 'value',
          name: '吨',
          // 横坐标轴颜色
          axisLine: {
            lineStyle: {
              color: '#14D5FF'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#14D5FF'
            }
          }
        },
        series: [
          {
            name: '原卷重量',
            type: 'line',
            color: '#E09C13',
            areaStyle: {
              color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(58,77,233,0.8)'
              }, {
                offset: 1,
                color: 'rgba(58,77,233,0.3)'
              }])
            },
            data: inData
          },
          {
            name: '成品重量',
            type: 'line',
            color: '#3BE232',
            areaStyle: {
              // color: '#94C9EC'
              color: new _this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                offset: 0,
                color: 'rgba(7,44,90,0.3)'
              }, {
                offset: 1,
                color: 'rgba(0,146,246,0.9)'
              }])
            },
            data: outData
          }
        ]
      }
      idChart.setOption(idChartOption)
    },
    // 加工类型统计
    zhuFn () {
      typeWeightList({})
        .then(res => {
          this.hebaoData = []
          this.kaipingData = []
          this.fenjuanData = []
          this.zhongjianData = []
          this.chaibaoData = []
          this.nameData = []
          res.forEach((item, index) => {
            this.nameData.push(item.transportDate)
            this.hebaoData.push(item.hebaoWeight)
            this.kaipingData.push(item.kaipingWeight)
            this.fenjuanData.push(item.fenjuanWeight)
            this.zhongjianData.push(item.zhongjianWeight)
            this.chaibaoData.push(item.chaibaoWeight)
          })
          let myChart = this.$echarts.init(document.getElementById('zhu'))

          // 绘制图表--柱状
          myChart.setOption({
            color: ['#0DD9FE', '#52F23A', '#FFAF03', '#ff5b00', '#ff0'],
            // backgroundColor: "#323a5e",
            grid: {
              left: '2%',
              right: '4%',
              bottom: '9%',
              top: '20%',
              containLabel: true
            },
            legend: {
              icon: 'circle',
              data: ['开平', '拆包', '纵剪', '分卷', '合包'],
              textStyle: {
                color: '#fff'
              }
            },
            // ---  提示框 ----
            tooltip: {
              show: true, // 是否显示提示框，默认为true
              trigger: 'item', // 数据项图形触发
              axisPointer: {
                // 指示样式
                type: 'shadow',
                axis: 'auto'
              },
              padding: 5,
              textStyle: {
                // 提示框内容的样式
                color: '#fff'
              }
            },
            calculable: true,
            xAxis: {
              type: 'category',
              data: this.nameData,
              axisLine: {
                lineStyle: {
                  color: 'white'
                }
              },
              axisLabel: {
                interval: 0,
                rotate: 40,
                textStyle: {
                  fontFamily: 'Microsoft YaHei'
                }
              }
            },
            yAxis: {
              type: 'value',
              data: ['2000', '4000', '6000', '8000'],
              name: '吨',
              axisLine: {
                show: false,
                lineStyle: {
                  color: 'white'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: 'rgba(255,255,255,0.3)'
                }
              },
              axisLabel: {}
            },
            series: [
              {
                name: '开平',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: this.kaipingData
              },
              {
                name: '拆包',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: this.chaibaoData
              },
              {
                name: '纵剪',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: this.zhongjianData
              },
              {
                name: '分卷',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: this.fenjuanData
              },
              {
                name: '合包',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: this.hebaoData
              }
            ]
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 类型分布
    getdata () {
      totalList().then(res => {
        this.tongji = res
        let arr = []
        arr.push({ name: '开平', value: res.kaiping })
        arr.push({ name: '拆包', value: res.chaibao })
        arr.push({ name: '纵剪', value: res.zhongjian })
        arr.push({ name: '分卷', value: res.fenjuan })
        arr.push({ name: '合包', value: res.hebao })
        this.pie(arr, '类型分布', 'LXpie')
      })
    },
    pie (data, name, id) {
      let _this = this
      var img = 'data:image/png;base64,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'
      let idChart = _this.$echarts.init(document.getElementById(id))
      var dataArr = []
      var color = ['#00ffff', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000', '#00cfff']
      for (var i = 0; i < data.length; i++) {
        dataArr.push({
          value: data[i].value,
          name: data[i].name,
          itemStyle: {
            normal: {
              borderWidth: 5,
              shadowBlur: 20,
              borderColor: color[i],
              shadowColor: color[i]
            }
          }
        }, {
          value: 1,
          name: '',
          itemStyle: {
            normal: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              color: 'rgba(0, 0, 0, 0)',
              borderColor: 'rgba(0, 0, 0, 0)',
              borderWidth: 0
            }
          }
        })
      }
      var seriesOption = [{
        name: '',
        type: 'pie',
        clockWise: false,
        radius: [130, 140],
        hoverAnimation: false,
        itemStyle: {
          normal: {
            label: {
              show: true,
              position: 'outside',
              color: '#ddd',
              fontSize: '18',
              formatter: function (params) {
                if (params.name) {
                  let valueTxt = ''
                  if (params.name.length > 5) {
                    valueTxt = params.name.substring(0, 6) + '...' // 想要展示的x轴名称长度
                  } else {
                    valueTxt = params.name
                  }
                  return valueTxt + '：' + params.value
                }
              }
            }
          }
        },
        data: dataArr
      }]
      var option = {
        backgroundColor: 'rgba(225,225,225,0)',
        color: color,
        title: {
          text: name,
          top: '48%',
          textAlign: 'center',
          left: '49%',
          textStyle: {
            color: '#fff',
            fontSize: 30,
            fontWeight: '400'
          }
        },
        graphic: {
          elements: [{
            type: 'image',
            z: 3,
            style: {
              image: img,
              width: 210,
              height: 210
            },
            left: 'center',
            top: 'center',
            position: [100, 100]
          }]
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.5)',
          formatter: function (params) {
            var percent = 0
            var total = 0
            for (var i = 0; i < data.length; i++) {
              if (data[i].value) {
                total += data[i].value
              }
            }
            if (total == 0) {
              percent = 0
            } else {
              percent = ((params.value / total) * 100).toFixed(0)
            }

            return params.marker + '<span style="color:' + params.color + '">' + params.data['name'] + '\n' + params.data['value'] + '</span></br>' + '占百分比：' + percent + '%'
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        series: seriesOption
      }
      idChart.setOption(option)
    },
    // 获取当前时间
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '/' + mm + '/' + dd
    }
  },
  computed: {
    optionSingleHeightTime () {
      return {
        // singleHeight: 26,
        // waitTime: 2500,
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.churutableData.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1200 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  filters: {
    formatDate: function (cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =

      month +
      '.' +
      date +
      ' ' +
      hour +
      ':' +
      minutes
      }
      return str
    }
  },
  destroyed () {
    clearInterval(this.nowTimer)
    clearInterval(this.timer)
  }
}
</script>

<style lang="less" scoped>
.center{
  .box{
    text-align: center;
    color:#fff;
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p{
      margin: 0;
    }
    .font{
      font-size: 55px;
      margin-top: 10px;
      color: #ff0;
    }
  }
}
.heard {
  width: 100%;
  height: 6vh;
  line-height: 6vh;
  display: flex;
  background: url("../../../assets/dapingImg/标题光条.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  .title {
    flex: 1;
    font-size: 30px;
    font-weight: 700;
    color: #03faec;
    margin-right: 60px;
  }
  .date {
    font-size: 16px;
    color: #ffdd17;
  }
   .img{
    height: 6vh;
    display: flex;
    .name{
      color: #03faec;
      margin-bottom: 20px;
      margin-left: 10px;
    }
    img{
      height: 100%;
    }
  }
}
.maps {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background:url('../../../assets/dapingImg/bg.png') 100%;

}
/*左右固定，中间自适应  利用绝对定位*/
.container {
  width: 100%;
  height: 91vh;
  position: relative;
  margin-top: 20px;
  padding: 0 20px;
  box-sizing: border-box;
}
.left_two {
  //折线图
  // background-color: #ccc;
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 44vh;
  overflow: hidden;
  width: 100%;
  background: url("../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;
  // overflow-x: scroll;
}

.left_h {
  height: 30px;
  line-height: 30px;
  color: #03faec;
  // font-weight: 700;
  font-size: 20px;
  background: url("../../../assets/dapingImg/mk-title-bg.png") no-repeat;
  background-size: 100% 100%;
  .span_one {
    float: left;
    margin-left: 10px;
    font-size: 16px;
  }
  .span_two {
    float: right;
    margin: 5px;
    font-size: 16px;

    font-weight: normal;
  }
}
.left_table {
  width: 100%;
  height: 85vh;
  overflow: hidden;
  .tables {
    background-color: #0565f7;
    width: 100%;
    color: #fff;
    height: 5vh;
    line-height: 5vh;
    display: flex;
    text-align: center;
    span {
      // flex: 1;
      width: 20%;
    }
    .span_one {
      // flex: 1;右侧
      width: 50%;
    }
    .span_one3 {
      // flex: 1;客户
      width:100px;
    }
    .span_one1 {
      // flex: 1; 钢卷
      width: 45%;
    }
    .span_one2 {
      // flex: 1;时间
      width: 25%;
    }
  }
}
.seamless-warp {
  overflow: hidden;
  ul {
   margin: 0;
   padding: 0;
// margin-top: 10px;
  }
  li {
    display: flex;
    width: 100%;
    height: 4vh;
    line-height: 4vh;
    color: #3fd2ff;
 display: -webkit-flex;
          -webkit-flex-direction:row;
    span {
      // flex: 1;
      width:20%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      // padding: 0 2px;
      text-align: center;
    }
    .span1{
       width:45%;
    }
    .span2{
       width:25%;
    }
    .span3{
       width:100px !important;
    }
    .span {
      // flex: 1;
      width:50%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .colorYellow {
    // border: 1px solid yellow;
    color: #eed808;
  }
}
</style>
